import { cn } from "@/lib/utils";

/**
 * The house 1px rule that fades out at the page gutters. Opacity is set by the caller
 * with a text color utility, because `rule-fade` draws itself from `currentColor`.
 */
export function FadingRule({ className }: { className?: string }) {
    return <div role="presentation" className={cn("rule-fade", className)} />;
}
